import { ConfigProvider } from "antd";
import "antd/dist/reset.css";
import type { AppProps } from "next/app";
import dynamic from "next/dynamic";
import { FC } from "react";
import { Provider } from "react-redux";
import ErrorBoundary from "../components/Error/ErrorBoundary";
import { SEO } from "../components/Shared";
import Layout from "../components/Shared/Layout";
import { AppLoadingLoader } from "../components/Shared/Loaders";
import { store } from "../lib/redux/store";
import "../styles/globals.css";
import { antdGlobalTheme } from "../themes/constants";
import "../utils/extensions";
import useV3Middleware from "../v.3.middleware";

const App: FC<AppProps> = ({ Component, pageProps }) => {
  const { onFinish } = useV3Middleware();

  return onFinish ? (
    <ConfigProvider theme={antdGlobalTheme}>
      <SEO title="OX Delivers Portal" />
      <Provider store={store}>
        <Layout>
          <ErrorBoundary>
            <Component {...pageProps} />
          </ErrorBoundary>
        </Layout>
      </Provider>
    </ConfigProvider>
  ) : (
    <AppLoadingLoader />
  );
};

export default dynamic(() => Promise.resolve(App), {
  ssr: false,
  loading: () => <AppLoadingLoader />
});
